(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const SCROLL_THRESHOLD_PX = 24;

    function initHeader(headerEl) {
      if (headerEl.dataset.headerInit === '1') return;
      headerEl.dataset.headerInit = '1';

      var drawer = document.getElementById('hdr-drawer');
      var openBtn = headerEl.querySelector('[data-drawer-open]');
      var closeBtn = drawer ? drawer.querySelector('[data-drawer-close]') : null;
      var navItems = Array.prototype.slice.call(
        headerEl.querySelectorAll('.hdr__nav-item.has-submenu')
      );

      var scrolled = false;
      var scrollPending = false;
      var lastFocus = null;

      function setHeaderHeight() {
        var h = headerEl.offsetHeight;
        if (h) {
          document.documentElement.style.setProperty('--header-height', h + 'px');
        }
      }

      function onScroll() {
        if (scrollPending) return;
        scrollPending = true;
        requestAnimationFrame(function () {
          var shouldBeScrolled = window.scrollY > SCROLL_THRESHOLD_PX;
          if (shouldBeScrolled !== scrolled) {
            scrolled = shouldBeScrolled;
            headerEl.classList.toggle('is-scrolled', shouldBeScrolled);
            requestAnimationFrame(setHeaderHeight);
          }
          scrollPending = false;
        });
      }

      function openDrawer() {
        if (!drawer) return;
        lastFocus = document.activeElement;
        drawer.removeAttribute('hidden');
        void drawer.offsetWidth;
        drawer.classList.add('is-open');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      }

      function closeDrawer() {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        var onEnd = function () {
          drawer.setAttribute('hidden', '');
          drawer.removeEventListener('transitionend', onEnd);
        };
        drawer.addEventListener('transitionend', onEnd);
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus();
        }
      }

      function onKeydown(e) {
        if (e.key !== 'Escape') return;
        if (drawer && drawer.classList.contains('is-open')) {
          closeDrawer();
          return;
        }
        var open = headerEl.querySelector('.hdr__nav-item.is-open');
        if (open) open.classList.remove('is-open');
      }

      function onDocClick(e) {
        if (!navItems.length) return;
        var inside = e.target.closest ? e.target.closest('.hdr__nav-item') : null;
        navItems.forEach(function (item) {
          if (item !== inside) item.classList.remove('is-open');
        });
      }

      // On touch-only devices the CSS :hover state never fires, so a tap on a
      // submenu's parent link goes straight to its href without ever revealing
      // the submenu. Intercept the first tap to toggle the submenu instead;
      // tapping the same link a second time (while open) lets navigation through.
      var hoverlessMQ = window.matchMedia('(hover: none)');
      function onSubmenuTriggerClick(e) {
        if (!hoverlessMQ.matches) return;
        var item = e.currentTarget.closest('.hdr__nav-item.has-submenu');
        if (!item) return;
        if (item.classList.contains('is-open')) return; // second tap navigates
        e.preventDefault();
        navItems.forEach(function (other) {
          if (other !== item) other.classList.remove('is-open');
        });
        item.classList.add('is-open');
      }
      navItems.forEach(function (item) {
        var link = item.querySelector(':scope > .hdr__nav-link');
        if (link) link.addEventListener('click', onSubmenuTriggerClick);
      });

      setHeaderHeight();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', setHeaderHeight, { passive: true });
      document.addEventListener('keydown', onKeydown);
      document.addEventListener('click', onDocClick);
      if (openBtn) openBtn.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      onScroll();
    }

    function init() {
      document.querySelectorAll('header[data-header]').forEach(initHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-content"] && !Shopify.designMode) return;
  try {
    
class BlfcParallax extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('.blfc-parallax__media');
    if (!this.image) return;

    // Touch and reduced-motion fall back to the static cover image styled above.
    const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isTouch || reduced) return;

    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    const rect = this.getBoundingClientRect();
    const viewport = window.innerHeight;

    // Skip work while off screen.
    if (rect.bottom < 0 || rect.top > viewport) return;

    const travel = parseFloat(getComputedStyle(this).getPropertyValue('--blfc-parallax-travel')) || 0;
    if (!travel) return;

    // 0 as the section enters from the bottom, 1 as it leaves past the top.
    const raw = (viewport - rect.top) / (viewport + rect.height);
    const progress = Math.min(1, Math.max(0, raw));

    // -travel/2 through +travel/2.
    const offset = travel * (progress - 0.5);
    this.image.style.transform = `translate3d(0, ${offset}px, 0)`;
  }
}

if (!customElements.get('blfc-parallax')) {
  customElements.define('blfc-parallax', BlfcParallax);
}

  } catch(e) { console.error(e); }
})();
})();
